import { Routes } from '@angular/router';

import { authGuard } from '@auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/components/auth/auth.component').then((m) => m.AuthComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./main/main.routes').then((r) => r.mainRoutes),
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
